module.exports = __webpack_public_path__ + "static/12-55c71448132d76743a66bacb31f3ad2b.jpg";